// The sections of the knowledge base (R-U16, um/2026-10-30/03 п.2): the chosen section and the open article live in the address
// (?section=, ?article=), shared by the left column, the list and a link; «none» stands for the articles without a section.

import type { RecordObj } from '@confdeck/core-shared';

export const TYPE_KEY = 'article';
export const TAXONOMY_KEY = 'kb_section';
/** The pseudo-section of articles without a section, in the address. */
export const NO_SECTION = 'none';
export const SORT = [{ field: 'order', dir: 'asc' as const }, { field: 'title', dir: 'asc' as const }];

/** The section of an article: the value of «Раздел» or the pseudo-section. */
export function sectionOf(rec: RecordObj): string {
  const v = rec.data.section;
  const id = Array.isArray(v) ? v[0] : v;
  return typeof id === 'string' && id ? id : NO_SECTION;
}

/** The order of an article: the number of «Порядок» or null. */
export function orderOf(rec: RecordObj): number | null {
  const v = rec.data.order;
  if (v == null || v === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

export const sectionHref = (id: string) => `/s/knowledge?section=${encodeURIComponent(id)}`;

/** The address of an article of a section; an empty article — the reading column closed on purpose. */
export const articleHref = (section: string, article: string) => `${sectionHref(section)}&article=${encodeURIComponent(article)}`;

/**
 * The article the reading column shows. A link names it (a direct visit opens it even before the list has come); without one the first
 * article of the section opens on a wide screen — once the articles are in, not on the empty list of the first render (MiniMax review
 * wave 2); on a phone the list comes first; an empty name means the person closed the article.
 */
export function articleToOpen(wanted: string | null, ids: string[], narrow: boolean): string | null {
  if (wanted !== null) return wanted || null;
  return narrow ? null : ids[0] ?? null;
}
